module.exports = __webpack_public_path__ + "static/media/dyng_overview.01905973.png";